/**
 * Return a URL only if it uses a safe (http/https) scheme, otherwise
 * undefined. Use this before putting a stored/user-supplied value into an
 * anchor `href` — a value like `javascript:...` would otherwise execute on
 * click. Protects against legacy rows saved before server-side validation.
 */
export function safeUrl(url: string | null | undefined): string | undefined {
  if (!url) return undefined;
  const trimmed = url.trim();
  return /^https?:\/\//i.test(trimmed) ? trimmed : undefined;
}
